// extracted by mini-css-extract-plugin
module.exports = {"root":"faq_root__aI99H","question":"faq_question__r8Pcw","answer":"faq_answer__JwV1A","openAnswer":"faq_openAnswer__cgmnv","activeQuestion":"faq_activeQuestion__UxLQy"};